import { render } from "./TheHeader.vue?vue&type=template&id=198e5aec&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=198e5aec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-198e5aec"

export default script